import React from "react"
import { Heading, Hero } from "react-bulma-components"
import SecondaryPage from "./SecondaryPage"

const ComingSoon: React.FC = () => {
  return (
    <SecondaryPage>
      <Hero color="primary" size="fullheight">
        <Hero.Header></Hero.Header>
        <Hero.Body className="has-text-centered fullheight-hero-body">
          <Heading size={1}>
            <img
              className="large-image invert-me"
              src="https://raw.githubusercontent.com/FortAwesome/Font-Awesome/d79d85c3fad85ad1885e87ed558f4afd6fce8289/svgs/regular/clock.svg"
              alt=""
            />
            <br />
            Coming soon
          </Heading>
          <Heading subtitle size={3}>
            <br />
            That's not quite ready yet...
            <br />
            Watch this space!
          </Heading>
        </Hero.Body>
      </Hero>
      <br />
    </SecondaryPage>
  )
}

export default ComingSoon
